/**
 * 格式化参数 (清除空值参数)
 * @param {Object} params 参数对象
 */
export const formatParams = (params) => {
	for (const key in params) {
		if (params[key] === "" || params[key] === undefined || params[key] === null) {
			delete params[key];
		}
	}

	return params;
};
